import { useForm } from "react-hook-form";
import { IStaffMember } from "../../Staff/staff-hook";
import { IStaffMemberForm } from "../../../../../../Interfaces/formValue-interfaces";
import { UserRoles } from "../../../../../../Interfaces/responseTypes";
import { ICreateStaffProps } from "./addStaffMemberDialog";


const useCreateStaffMember = (props:ICreateStaffProps) => {
    const {company_id,onCloseDialog,onCreate} = props;
    const {
        register,
        control,
        formState: { errors, isValid },
        getValues,
    } = useForm<IStaffMemberForm>({ mode: 'all' });

    const onAddMember = () => {
        const payload: IStaffMember = {
            first_name: getValues('first_name'),
            last_name: getValues('last_name'),
            phone_number: getValues('phone_number'),
            user_role: getValues('user_role').id as UserRoles,
            company_id: company_id,
            user_name:getValues('user_name'),
            password:getValues('password')
        };
        onCreate(payload);
        onCloseDialog()
    };

    return {
        register,
        control,
        onAddMember,
        errors,
        isValid
    }
};

export default useCreateStaffMember